<template>
  <div class="bright-points">
    <p class="title">亮点功能推荐</p>

    <div class="expandable-list">
      <div class="left-list">
        <div v-for="(item, index) in items" :key="index" class="item">
          <div class="header" @click="toggleItem(index)">
            <span class="header-title">{{ item.title }}</span>
            <span class="icon">{{ activeIndex === index ? '-' : '+' }}</span>
          </div>
          <div v-show="activeIndex === index" class="content">
            <p class="subtitle">{{ item.subTitle }}</p>
            <div class="content-detail">
              <img v-if="item.img" :src="item.img" alt="" />
              <video v-else :src="item.video" autoplay></video>
            </div>
            <p class="title-content">{{ item.content }}</p>
            <div class="action-content">
              <div class="action-trail" @click="trailClick">立即试用</div>
              <div class="action-example">
                <router-link to="/example/list">客户案例</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="right-list">
        <!-- <div class="content-detail"> -->
        <img v-if="currentImage" :src="currentImage" alt="" />
        <video v-else autoplay :src="currentVideo"></video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'brightPoints',
  data() {
    return {
      isBigScreen: false,
      activeIndex: 0,
      type: 'free',
      currentImage: '',
      currentVideo: '',
      list: {
        free: [
          {
            title: 'AI智能买纸板',
            subTitle: '送货记账',
            content: 'AI提效+数据降本，智能管理让纸箱厂利润飙升！',
            // img: require('@/assets/images/productFeatures/bg_customer.png'),
            img: '',
            video: require('@/assets/images/video.mp4')
          },
          {
            title: '纸箱报价',
            subTitle: '送货记账',
            content: '这里是纸箱报价的详细内容...',
            img: '',
            video: ''
          },
          {
            title: '智能找版',
            subTitle: '送货记账',
            content: '这里是智能找版的详细内容...',
            img: '',
            video: ''
          }
        ],
        agile: [
          {
            title: '送货记账',
            subTitle: '送货记账',
            content: 'AI提效+数据降本，智能管理让纸箱厂利润飙升！',
            img: '',
            video: ''
          },
          {
            title: '纸箱报价',
            subTitle: '送货记账',
            content: '这里是纸箱报价的详细内容...',
            img: '',
            video: ''
          },
          {
            title: '智能找版',
            subTitle: '送货记账',
            content: '这里是智能找版的详细内容...',
            img: '',
            video: ''
          }
        ],
        pro: [
          {
            title: '送货记账',
            subTitle: '送货记账',
            content: 'AI提效+数据降本，智能管理让纸箱厂利润飙升！',
            img: '',
            video: ''
          },
          {
            title: '纸箱报价',
            subTitle: '送货记账',
            content: '这里是纸箱报价的详细内容...',
            img: '',
            video: ''
          },
          {
            title: '智能找版',
            subTitle: '送货记账',
            content: '这里是智能找版的详细内容...',
            img: '',
            video: ''
          }
        ]
      },
      items: []
    }
  },
  created() {},
  mounted() {
    this.items = this.list[this.type]
    this.currentImage = this.items[0].img
    this.currentVideo = this.items[0].video
  },
  methods: {
    toggleItem(index) {
      if (this.activeIndex === index) {
        // this.activeIndex = null
      } else {
        this.activeIndex = index
        this.currentImage = this.items[index].img
        this.currentVideo = this.items[index].video
      }
    },
    trailClick() {
      window.open('https://zxcerptest.cpsol.net/trial.html')
      // this.$router.push({
      //   path: '/product/freeUse'
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.bright-points {
  margin-top: 32px;
  padding: 20px;
  // max-width: 1400px;
  // margin: 0 auto;
  background: linear-gradient(180deg, #ffffff 0%, #e7edf7 100%);
  .title {
    text-align: center;
    font-weight: 500;
    font-size: 32px;
    color: #333333;
    // padding-bottom: 40px;
  }

  .expandable-list {
    // max-width: 1400px;
    // margin: 0 auto;
    margin: 10px;
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    overflow: hidden;
    background: #ffffff;
    box-shadow: 0px 0 15px 0px rgba(0, 0, 0, 0.07);

    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 24px;
      cursor: pointer;

      font-weight: 500;
      font-size: 16px;
      color: #333333;
      .header-title {
        font-size: 24px;
        font-weight: bold;
      }
    }
    .left-list {
    }
    .right-list {
      display: none;
    }
    .content {
      padding: 15px 0px;
      border-top: 1px solid #e0e0e0;
      background: linear-gradient(
        180deg,
        rgba(0, 157, 247, 0) 0%,
        rgba(0, 100, 235, 0.05) 100%
      );
      .subtitle {
        font-weight: 500;
        font-size: 24px;
        color: #333333;
        padding: 0 16px;
      }
      .title-content {
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        padding: 0 20px;
      }
      .content-detail {
        display: flex;
        justify-content: center;
        // align-items: center;
        margin: 16px 0;
        width: 100%;
        background-image: url('../../../assets/images/yzxBuyEntrance/bg_point.png');
        background-position: center;
        background-size: cover;
        // height: 172px;
        // max-height: 180px;

        padding: 40px;
        img {
          max-width: 80%;
          object-fit: contain;
        }
        video {
          max-width: 80%;
          object-fit: contain;
        }
      }
      .action-content {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        padding: 20px 0;
        .action-trail {
          background: #0064eb;
          height: 38px;
          margin-bottom: 0px;
          margin-right: 11px;
          color: #ffffff;
          width: 134px;
          // border: 1px solid #ffffff;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .action-example {
          height: 38px;
          width: 134px;
          background: transparent;
          border: 1px solid #0064eb;
          color: #0064eb;
          display: flex;
          justify-content: center;
          align-items: center;
          a {
            // color: #ffffff;
          }
        }
      }
    }
  }
}

.item {
  border-bottom: 1px solid #ededed;
}

.item:last-child {
  border-bottom: none;
}

.icon {
  font-size: 32px;
  font-weight: bold;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}

@media (min-width: 751px) and (max-width: 960px) {
  .bright-points {
    .expandable-list {
      max-width: 1400px;
      margin: 0 auto;
      display: flex;
      background: #ffffff;
      box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.07);
      border-radius: 4px;
      .right-list {
      }
    }
  }
}

@media (min-width: 961px) {
  .bright-points {
    .expandable-list {
      max-width: 1400px;
      margin: 0 auto;
      background: #ffffff;
      box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.07);
      border-radius: 4px;
      display: flex;
      .left-list {
        width: 40%;
      }
      .content {
        .content-detail {
          display: none;
        }
        .action-content {
          font-size: 14px;
          justify-content: flex-start;
          padding-left: 20px;
          .action-trail {
            width: 127px;
            height: 36px;
          }
          .action-example {
            width: 127px;
            height: 36px;
          }
        }
      }

      .right-list {
        display: flex;
        justify-content: center;
        // align-items: center;
        flex: 1;
        width: 100%;
        background-image: url('../../../assets/images/yzxBuyEntrance/bg_point.png');
        background-position: center;
        background-size: cover;
        max-height: 450px;
        img {
          max-width: 80%;
          object-fit: contain;
        }
        video {
          max-width: 80%;
          object-fit: contain;
        }
      }
    }
  }
}
</style>
